import { CareguidelinesPage } from "./careguidelinesPage";

export const Careguidelines = CareguidelinesPage;
